/**
 * Onde fica a API do OPS.
 *
 * O PDV nasceu offline-first, para rodar NA LOJA: o endereço da API era um IP
 * da rede local ("10.6.0.194"), o código colava "http://" na frente e ":9898"
 * atrás, e pronto. Isso não sobe para a nuvem por dois motivos:
 *
 *  1. na nuvem a API atende em https, na porta 443, num nome (onrender.com) —
 *     não em http://IP:9898;
 *  2. uma página servida por https NÃO consegue chamar http://IP:9898: o
 *     navegador bloqueia como conteúdo misto. Ou seja, a versão de nuvem do
 *     PDV nunca vai falar com um servidor de loja, e vice-versa.
 *
 * Então o endereço passa a aceitar três formas, nesta ordem de prioridade:
 *   - o que o usuário digitou/escolheu (guardado no zustand), já com esquema
 *     ("https://alfredo-ops-api.onrender.com") ou ainda como IP puro
 *     ("10.6.0.194", que vira "http://10.6.0.194:9898", o jeito antigo);
 *   - REACT_APP_API_URL, definida no build (é assim que a instância de nuvem
 *     sobe já apontando para o alfredo-ops-api);
 *   - vazio, e aí o PDV pede a loja na tela.
 */

const PORTA_PADRAO_DA_LOJA = 9898;

/** Normaliza o que o usuário digitou para uma URL de verdade. */
export function normalizarEnderecoDaApi(valor?: string | null): string {
  const bruto = (valor ?? "").trim();
  if (!bruto) return "";

  // Já veio com esquema: respeita como está (nuvem, ou loja atrás de proxy).
  if (/^https?:\/\//i.test(bruto)) {
    return bruto.replace(/\/+$/, "");
  }

  // Veio só o host/IP: é o caso da loja. Mantém o comportamento antigo.
  const temPorta = /:\d+$/.test(bruto);
  return `http://${bruto.replace(/\/+$/, "")}${temPorta ? "" : `:${PORTA_PADRAO_DA_LOJA}`}`;
}

/** Endereço vindo do build (usado pela instância publicada na nuvem). */
export function enderecoPadraoDoAmbiente(): string {
  return normalizarEnderecoDaApi(process.env.REACT_APP_API_URL);
}

/** Endereço efetivo: o escolhido pelo usuário, senão o do ambiente. */
export function resolverEnderecoDaApi(enderecoGuardado?: string | null): string {
  return normalizarEnderecoDaApi(enderecoGuardado) || enderecoPadraoDoAmbiente();
}

/**
 * Diz se a página está em https e o endereço da API em http — combinação que o
 * navegador bloqueia. Serve para explicar o erro em vez de deixar "ERR_NETWORK".
 */
export function haConteudoMisto(endereco: string): boolean {
  if (typeof window === "undefined") return false;
  return window.location.protocol === "https:" && /^http:\/\//i.test(endereco);
}
